import { Settings as LayoutSettings } from '@ant-design/pro-layout';

export default {
  menu: {
    locale: true,
  },
  pwa: true,
  title: 'DPAS',
  iconfontUrl: '',
  navTheme: 'light',
  colorWeak: false,
  contentWidth: 'Fluid',
  colorPrimary: '#00aec3',
} as LayoutSettings & {
  pwa: boolean;
};
